import createUUID from "../../utils/uuid";

let templates = [];

templates['small_image_text'] = {
    body: defineBody(lng => [
        createTextSection(lng, 0, '<img src="https://cdn-assets.productfruits.com/40cf6f62-07e6-47d3-be7d-df327c7fad03" style="max-width: 100%; width: 55px; float: left; margin-right: 10px" class="">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam varius metus nec elit fermentum scelerisque. Integer imperdiet dui at lorem fringilla, a iaculis augue vehicula.')
    ])
}

templates['large_image_text'] = {
    body: defineBody(lng => [
        createTextSection(lng, 0, '<img src="https://cdn-assets.productfruits.com/40cf6f62-07e6-47d3-be7d-df327c7fad03" style="max-width: 100%; width: 200px; float: left; margin-right: 10px" class="">'),
        createTextSection(lng, 0, 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam varius metus nec elit fermentum scelerisque.')
    ])
}

templates['welcome'] = {
    body: defineBody(lng => [
        createTextSection(lng, 0, '<div><span style="font-size: 24px; font-weight: bold; color: white;" pfsize="large"><br></span></div><span style="font-size: 24px; font-weight: bold; color: white;" pfsize="large"><div style="text-align: center;">Welcome to the application!</div></span><div><span style="font-size: 24px; font-weight: bold; color: white;" pfsize="large"><br></span></div>', 'rgb(65, 88, 208)'),
        createTextSection(lng, 1, 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam varius metus nec elit fermentum scelerisque. Integer imperdiet dui at lorem fringilla, a iaculis augue vehicula. Pellentesque consectetur egestas dui ut molestie. Praesent accumsan pulvinar ex vel aliquet. Nunc sed sem et mi auctor rhoncus imperdiet at tellus. Donec tristique pretium quam, eu iaculis ante posuere quis.')
    ])
}

templates['wide_image_text'] = {
    body: defineBody(lng => [
        createTextSection(lng, 0, 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam varius metus nec elit fermentum scelerisque. Integer imperdiet dui at lorem fringilla, a iaculis augue vehicula.'),
        createTextSection(lng, 1, '<img src="https://cdn-assets.productfruits.com/6cfb0b33-ce40-4deb-98ec-8b4a99a33b8a" style="max-width: 100%; width: auto;" class="">')
    ])
}

templates['adoption_meter'] = {
    body: defineBody(lng => [
        createTextSection(lng, 0, 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam varius metus nec elit fermentum scelerisque. Integer imperdiet dui at lorem fringilla, a iaculis augue vehicula.'),
        createAdoptionMeterSection(lng, 1)
    ])
}

templates['text_video_below'] = {
    body: defineBody(lng => [
        createTextSection(lng, 0, 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam varius metus nec elit fermentum scelerisque. Integer imperdiet dui at lorem fringilla, a iaculis augue vehicula.'),
        createVideoSection(lng, 1, 'https://www.youtube.com/watch?v=ScMzIvxBSi4', 'https://www.youtube.com/embed/ScMzIvxBSi4')
    ])
}

templates['text_video_borderless'] = {
    body: defineBody(lng => [
        createVideoSection(lng, 0, 'https://www.youtube.com/watch?v=ScMzIvxBSi4', 'https://www.youtube.com/embed/ScMzIvxBSi4')
    ]),
    footer: {
        visible: false
    }
}

function createTextSection(lng, row, text, bgColor) {
    return createSection(lng, row, {
        bgColor,
        text: {
            [lng]: text
        }
    });
}

function createVideoSection(lng, row, url, embedUrl) {
    return createSection(lng, row, {
        dataId: createUUID(),
        video: {
            url: embedUrl,
            origUrl: url
        }
    });
}

function createAdoptionMeterSection(lng, row) {
    return createSection(lng, row, {
        dataId: createUUID(),
        mood: {
            tag: 'My Feature',
            question: {
                [lng]: 'How easy was this flow?'
            },
            followUp: {
                [lng]: 'Do you want to add something?'
            }
        }
    });
}

function createSection(lng, row, sectionCfg) {
    let obj = {
        row: row
    };

    return Object.assign(obj, sectionCfg, {});
}

function defineBody(sections) {
    if (!window.auth || !window.auth.project) return {};
    let bodyObj = {};
    for (const lng of window.auth.project.SupportedLanguages) {
        bodyObj[lng] = sections(lng);
    }
    return bodyObj;
}

export default templates;
